import { EmployeeAdvanceSettlementSourceType } from "features/EmployeeAdvanceSettlements/constants/employee-advance-settlement.constants";
import type { Settlement } from "features/EmployeeAdvanceSettlements/types/employee-advance-settlement.types";

/** For PAYROLL, `source` is the PayrollItem — it has no code of its own, fall back to its parent run's. */
export function resolveEmployeeAdvanceSettlementSourceCode(
  sourceType: EmployeeAdvanceSettlementSourceType | string | null | undefined,
  source: Settlement["source"],
): string | null {
  const code =
    source?.code?.trim() ||
    (sourceType === EmployeeAdvanceSettlementSourceType.PAYROLL
      ? source?.payrollRun?.code?.trim()
      : undefined);
  return code || null;
}

/**
 * For PAYROLL, `sourceId` is the PayrollItem's own id — not a valid `/finance/payroll/:id`
 * target. Link to the parent run's id instead; other source types link by sourceId as-is.
 */
export function resolveEmployeeAdvanceSettlementSourceLinkId(
  sourceType: EmployeeAdvanceSettlementSourceType | string | null | undefined,
  sourceId: number | string | null | undefined,
  source: Settlement["source"],
): number | string | null {
  if (sourceType === EmployeeAdvanceSettlementSourceType.PAYROLL) {
    return source?.payrollRun?.id ?? null;
  }
  return sourceId ?? null;
}
